import {
  EventCategories,
  EventNames,
  TrackingEventTypes,
  useAnalytics,
} from '@cinch-nx/shared-analytics'

export const useNavigationButtonTracking = () => {
  const trackEvent = useAnalytics((state) => state.trackEvent)

  const onNavigationButtonClick = () => {
    const evt = {
      event: {
        name: EventNames.click,
        category: EventCategories.button,
        label: 'search_all_autotrader_cars',
        action: 'search',
      },
    }
    trackEvent({
      eventName: 'Click on "Search all Autotrader cars" button',
      type: TrackingEventTypes.ADOBE,
      data: evt,
    })
  }

  return {
    onNavigationButtonClick,
  }
}
